import script from "./BonusList.vue?vue&type=script&setup=true&lang=js"
export * from "./BonusList.vue?vue&type=script&setup=true&lang=js"

import "./BonusList.vue?vue&type=style&index=0&id=1fdef412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdef412"]])

export default __exports__